var ErrorHandlerModule = require('../modules/errorHandler')

var Module = {
    name: 'ajaxForm',
    validationRules: require('../misc/validation-rules.js'),
    validationSuccessClass: 'has-success',
    validationErrorClass: 'has-error',
    selectors: {
        errorContainer: '#messageBox',
        modalContainer: '.modal-container',
        preloader: '#preloader'
    },

    validate: function (form, rules, messages, errorContainer) {
        let validate = form.validate({
            errorLabelContainer: errorContainer || Module.selectors.errorContainer,
            highlight: function(element) {
                $(element).closest('.form-group, .ct-form-item, .freque, .cnt-form-item, .cmt-form-item, .lh-validation-item')
                    .removeClass(Module.validationSuccessClass)
                    .addClass(Module.validationErrorClass);
                
                if($(element).closest('.cnt-form-step').find('.has-error').length !== 0) {
                    $(element).closest('.cnt-form-step').addClass('has-error-section');
                }
            },
            unhighlight: function(element) {
                $(element)
                    .closest('.form-group, .ct-form-item, .freque, .cnt-form-item, .cmt-form-item, .lh-validation-item')
                    .removeClass(Module.validationErrorClass)
                    .addClass(Module.validationSuccessClass);

                if($(element).closest('.cnt-form-step').find('.has-error').length === 0) {
                    $(element).closest('.cnt-form-step').removeClass('has-error-section');
                }
            },
            errorPlacement: function(error, element) {
                element.closest('.has-error').append(error);
            },
            rules: rules,
            messages: messages
        });

        $(document).on("select2:select", "select", function (e) {
            $(this).valid();
        });

        return validate;
    },

    submit: function (form, callback, errCallback, errorContainer = null, preloader = true) {
        var url = form.attr('action'),
            method = form.attr('method'),
            data = form.serialize();

        ErrorHandlerModule.hideErrors();
        $.ajax({
            type: method,
            url: url,
            dataType: "json",
            data: data,
            headers: {
                'Accept': 'application/json'
            },
            beforeSend: function() {
                $(Module.selectors.modalContainer).hide()
                if (preloader) {
                    $(Module.selectors.preloader).show();
                }
            }
        })
            .done(function(response) {
                if (callback && typeof(callback) == "function") {
                    callback(response)
                } else {
                    window.location = response.url;
                }
            })
            .fail(function(response) {
                var statusCode = parseInt(response.status);
                if (statusCode === 400) {
                    ErrorHandlerModule.processBadRequest(response.responseJSON, form);
                }

                if (statusCode === 422 || statusCode === 429) {
                    ErrorHandlerModule.showErrors(response.responseJSON.errors, errorContainer);
                }

                if (statusCode === 419) {
                    ErrorHandlerModule.processTokenMismatch();
                }

                if (errCallback && typeof(errCallback) == "function") {
                    errCallback(response)
                }
            })
            .always(function() {
                setTimeout(function() {
                    $(Module.selectors.preloader).hide();
                }, 1000);
            })
    }
}

module.exports = Module
